import { useMemo } from 'react';

import { Divider, type DividerProps } from '@frontend/legacy-components';

import { CASCADER_SUBCOMPONENT_NAMES } from '../consts';
import { useCascaderState, useCascaderComponentsContext } from '../context';
import type { CascaderOption, CascaderCommonProps } from '../types';

export interface IndicatorSeparatorProps<OptionType extends CascaderOption>
  extends DividerProps {
  getCommonProps: () => CascaderCommonProps<OptionType>;
}

export const InternalIndicatorSeparator = <
  OptionType extends CascaderOption,
>() => {
  const { cascaderStyles, getCommonProps } = useCascaderState<OptionType>();
  const { getComponent } = useCascaderComponentsContext<OptionType>();
  const CustomIndicatorSeparator = useMemo(
    () => getComponent(CASCADER_SUBCOMPONENT_NAMES.INDICATOR_SEPARATOR),
    [getComponent],
  );

  return (
    <CustomIndicatorSeparator
      getCommonProps={getCommonProps}
      __css={cascaderStyles.indicatorSeparator}
      className="cascader-indicator-separator"
    />
  );
};

export const IndicatorSeparator = <OptionType extends CascaderOption>({
  getCommonProps: _,
  ...rest
}: IndicatorSeparatorProps<OptionType>) => {
  return <Divider orientation="vertical" {...rest} />;
};
